export default function Testimonials() {
  return (
    <section className="relative py-20 overflow-hidden border-t border-white/10">
      {/* Background with darker overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            O Que Nossos Clientes Dizem
          </h2>
          <p className="text-xl text-gray-300">
            Experiências reais de quem confia na Steel Importações
          </p>
        </div>

        {/* Real Google Reviews Grid - Only 2 real testimonials */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12 max-w-5xl mx-auto">
          {/* Real Review 1 - Ricardo Lima */}
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-6 md:p-8 shadow-2xl">
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/66f9a908c76fd0bdd5995091c9a8253e.jpeg"
                alt="Avaliação Google - Ricardo Lima"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>

            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-bold text-lg">
                RL
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Ricardo Lima</h3>
                <div className="flex gap-1 mt-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>
            </div>

            <p className="text-gray-200 text-base leading-relaxed mb-3">
              "Excelente experiência! Compra segura, contrato formal assinado e entrega dentro do prazo (9 dias úteis). Produto chegou em perfeitas condições. Importador sério e confiável, recomendo!"
            </p>

            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <i className="ri-time-line"></i>
              <span>3 meses atrás</span>
            </div>
          </div>

          {/* Real Review 2 - Thalita Santos */}
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-6 md:p-8 shadow-2xl">
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/f48dd8b51d8d9443b058ef78a116d67c.jpeg"
                alt="Avaliação Google - Thalita Santos"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>

            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-bold text-lg">
                TS
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Thalita Santos</h3>
                <div className="flex gap-1 mt-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>
            </div>

            <p className="text-gray-200 text-base leading-relaxed mb-3">
              "Adorei! Veio tudo certinho, chegou antes do prazo, super recomendo!"
            </p>

            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <i className="ri-time-line"></i>
              <span>há 2 meses</span>
            </div>
          </div>
        </div>

        {/* Google Reviews Button */}
        <div className="flex justify-center">
          <a
            href="https://share.google/KJtca0APIjRDM0N6p"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-white hover:bg-gray-100 text-gray-900 font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 sm:gap-3 text-sm sm:text-base whitespace-normal sm:whitespace-nowrap"
          >
            <i className="ri-google-fill text-lg sm:text-2xl flex-shrink-0"></i>
            <span className="text-center break-words">Ver Todas as Avaliações no Google</span>
          </a>
        </div>
      </div>
    </section>
  );
}
